export const createDynamicBlogNavigation = () => {
  const headings = document.querySelectorAll(".js-h2-dynamic-navigation h2");
  if (headings.length === 0) return;

  // Create navigation container
  const nav = document.createElement("nav");
  nav.classList.add("blog-navigation");
  const ul = document.createElement("ul");
  nav.appendChild(ul);

  // Offset for sticky navigation (adjust this value as needed)
  const OFFSET = 120;

  // Store navigation links for observer
  const navLinks = new Map();

  headings.forEach((heading) => {
    // shopify sometimes delivers different markup for headings in blog articles
    let text = heading.querySelector("span");
    if (!text) {
      text = heading;
    }
    const headingText = text.textContent;

    // Ensure the heading has an ID for linking
    if (!heading.id) {
      heading.id = headingText
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, ""); // Generate ID from heading text
    }

    // Add copy link icon to heading
    const linkIconWrapper = document.createElement("div");
    linkIconWrapper.classList.add("heading-link-wrapper");
    linkIconWrapper.style.cssText =
      "position: relative; display: inline-block;";

    const linkIcon = document.createElement("button");
    linkIcon.innerHTML = `<svg style="width:22px; height: 22px;" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg"><rect fill="none" height="256" width="256"/><path d="M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>`;
    linkIcon.classList.add("heading-link-icon");
    linkIcon.setAttribute("aria-label", "Link kopieren");

    // Create custom tooltip
    const tooltip = document.createElement("div");
    tooltip.classList.add("heading-link-tooltip");
    tooltip.textContent = "Link kopieren";
    tooltip.style.cssText = `
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      background: #333;
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s, visibility 0.2s;
      pointer-events: none;
      z-index: 1000;
      margin-bottom: 5px;
    `;

    // Add tooltip arrow
    const tooltipArrow = document.createElement("div");
    tooltipArrow.style.cssText = `
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid #333;
    `;
    tooltip.appendChild(tooltipArrow);

    // Show/hide tooltip on hover
    linkIconWrapper.addEventListener("mouseenter", () => {
      tooltip.style.opacity = "1";
      tooltip.style.visibility = "visible";
    });

    linkIconWrapper.addEventListener("mouseleave", () => {
      tooltip.style.opacity = "0";
      tooltip.style.visibility = "hidden";
    });

    // Add click event to copy URL to clipboard
    linkIcon.addEventListener("click", async (e) => {
      e.preventDefault();
      const url = `${window.location.origin}${window.location.pathname}#${heading.id}`;

      try {
        await navigator.clipboard.writeText(url);
        // Provide visual feedback
        const originalTooltipText = tooltip.firstChild.textContent;
        tooltip.firstChild.textContent = "Link kopiert";

        setTimeout(() => {
          tooltip.firstChild.textContent = originalTooltipText;
        }, 2000);
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        // Provide visual feedback
        const originalTooltipText = tooltip.firstChild.textContent;
        tooltip.firstChild.textContent = "Link kopiert";

        setTimeout(() => {
          tooltip.firstChild.textContent = originalTooltipText;
        }, 2000);
      }
    });

    // Assemble the wrapper
    linkIconWrapper.appendChild(linkIcon);
    linkIconWrapper.appendChild(tooltip);

    // Append the link icon wrapper to the heading
    heading.appendChild(linkIconWrapper);

    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = `#${heading.id}`;
    a.textContent = headingText;
    a.classList.add("nav-link"); // Add class for styling

    // Store the link for the observer
    navLinks.set(heading.id, a);

    // Add click event with offset
    a.addEventListener("click", (e) => {
      e.preventDefault();
      const targetElement = document.getElementById(heading.id);
      if (targetElement) {
        // Get the element's position relative to the viewport
        const rect = targetElement.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const targetPosition = rect.top + scrollTop - OFFSET;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });

    li.appendChild(a);
    ul.appendChild(li);
  });

  // Create Intersection Observer to track current section
  const observerOptions = {
    root: null,
    rootMargin: `-${OFFSET}px 0px -50% 0px`, // Account for sticky nav and trigger when heading reaches top
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const navLink = navLinks.get(entry.target.id);
      if (navLink) {
        if (entry.isIntersecting) {
          // Remove active class from all links
          navLinks.forEach((link) => link.classList.remove("active"));
          // Add active class to current link
          navLink.classList.add("active");
        }
      }
    });
  }, observerOptions);

  // Observe all headings
  headings.forEach((heading) => observer.observe(heading));

  const articleNavigation = document.querySelector("#article-navigation");
  if (articleNavigation) {
    articleNavigation.appendChild(nav);
    return;
  }
};
